import {createAction} from 'redux-actions'

export const remember = createAction('PANELS/LAST/REMEMBER', ({id, serial}, to) => ({id, serial, to}))
export const forget = createAction('PANELS/LAST/FORGET')